<template>
	<div
		id="side-menu"
		:class="{ showAside: showAsideMenu, hideAside: !showAsideMenu }"
	>
		<div class="tabBar" :class="showAsideMenu ? 'show-menu' : 'hide-menu'">
			<div class="header">
				<div class="gradientBackground"></div>
				<img
					src="../../public/svg/close.svg"
					v-if="showAsideMenu"
					@click="menuCollapse()"
					class="closeButton"
				/>
				<router-link to="/">
					<img src="../../public/svg/logo.svg" class="RR-logo" />
				</router-link>
				<img
					v-if="showAsideMenu"
					class="m-menu-logo"
					src="../../public/svg/logo-and-text.svg"
				/>
			</div>
			<div class="sidebarContent">
				<div class="navigationItems">
					<router-link to="/expenses">
						<div
							class="item expenses"
							:class="selectedMenu === 'expenses' ? 'selected' : ''"
						>
							<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
								<img
									v-if="selectedMenu === 'expenses'"
									src="../../public/svg/receipt-icon-green.svg"
								/>
								<img v-else src="../../public/svg/receipt-icon-white.svg" />
							</div>
							<div
								v-if="showAsideMenu"
								class="title"
								:class="showAsideMenu ? 'show-element' : 'hide-element'"
							>
								Expenses
							</div>
						</div>
					</router-link>
					<router-link to="/overview">
						<div
							class="item overview"
							:class="selectedMenu === 'overview' ? 'selected' : ''"
						>
							<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
								<img
									v-if="selectedMenu === 'overview'"
									src="../../public/svg/overview-icon-green.svg"
								/>
								<img v-else src="../../public/svg/overview-icon-white.svg" />
							</div>
							<div
								v-if="showAsideMenu"
								class="title"
								:class="showAsideMenu ? 'show-element' : 'hide-element'"
							>
								Overview
							</div>
						</div>
					</router-link>
					<router-link to="/export">
						<div
							class="item overview"
							:class="selectedMenu === 'export' ? 'selected' : ''"
						>
							<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
								<img
									v-if="selectedMenu === 'export'"
									src="../../public/svg/export-icon-green.svg"
								/>
								<img v-else src="../../public/svg/export-icon-white.svg" />
							</div>
							<div
								v-if="showAsideMenu"
								class="title"
								:class="showAsideMenu ? 'show-element' : 'hide-element'"
							>
								Export
							</div>
						</div>
					</router-link>
					<router-link to="/rapid-email">
						<div
							class="item overview"
							:class="selectedMenu === 'rapid-email' ? 'selected' : ''"
						>
							<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
								<img
									v-if="selectedMenu === 'rapid-email'"
									src="../../public/svg/envelope-icon-green.svg"
								/>
								<img v-else src="../../public/svg/envelope-icon-white.svg" />
							</div>
							<div
								v-if="showAsideMenu"
								class="title"
								:class="showAsideMenu ? 'show-element' : 'hide-element'"
							>
								Rapid Email
							</div>
						</div>
					</router-link>
					<!-- <router-link v-if="teamRole === 'admin'" to="/team">
						<div
							class="item team"
							:class="selectedMenu === 'team' ? 'selected' : ''"
						>
							<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
								<img
									v-if="selectedMenu === 'team'"
									src="../resources/images/icons/team/team-icon-green.svg"
								/>
								<img
									v-else
									src="../resources/images/icons/team/team-icon-white.svg"
								/>
							</div>
							<div
								v-if="showAsideMenu"
								class="title"
								:class="showAsideMenu ? 'show-element' : 'hide-element'"
							>
								Team
							</div>
						</div>
					</router-link> -->
					<router-link to="/setting">
						<div
							class="item settings"
							:class="selectedMenu === 'settings' ? 'selected' : ''"
						>
							<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
								<img
									v-if="selectedMenu === 'settings'"
									src="../../public/svg/settings-icon-green.svg"
								/>
								<img v-else src="../../public/svg/settings-icon-white.svg" />
							</div>
							<div
								v-if="showAsideMenu"
								class="title"
								:class="showAsideMenu ? 'show-element' : 'hide-element'"
							>
								Settings
							</div>
						</div>
					</router-link>
				</div>

				<div class="bottomActions">
					<a
						class="action changePassword"
						href="https://rapidreceipt.io/terms"
						target="_blank"
					>
						<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
							<img src="../../public/svg/terms-of-use-icon.svg" />
						</div>
						<div
							v-if="showAsideMenu"
							class="title"
							:class="showAsideMenu ? 'show-element' : 'hide-element'"
						>
							Terms of Use
						</div>
					</a>
					<a
						class="action changePassword"
						href="https://rapidreceipt.io/privacy"
						target="_blank"
					>
						<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
							<img src="../../public/svg/privacy-policy-icon.svg" />
						</div>
						<div
							v-if="showAsideMenu"
							class="title"
							:class="showAsideMenu ? 'show-element' : 'hide-element'"
						>
							Privacy Policy
						</div>
					</a>
					<div class="separator"></div>
					<div class="action changePassword" @click="showChangePwdModal">
						<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
							<img src="../../public/svg/reset-password-icon.svg" />
						</div>
						<div
							v-if="showAsideMenu"
							class="title"
							:class="showAsideMenu ? 'show-element' : 'hide-element'"
						>
							Change Password
						</div>
					</div>
					<!--div class="action changePassword" @click="showSwitchAccountModal">
						<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
							<img src="../../public/svg/reset-password-icon.svg" />
						</div>
						<div
							v-if="showAsideMenu"
							class="title"
							:class="showAsideMenu ? 'show-element' : 'hide-element'"
						>
							Switch Account
						</div>
					</div-->
					<div class="action logOut" @click="signOut">
						<div :class="{ sidebarIcon: true, drawerMode: showAsideMenu }">
							<img src="../../public/svg/logout-icon.svg" />
						</div>
						<div
							v-if="showAsideMenu"
							class="title"
							:class="showAsideMenu ? 'show-element' : 'hide-element'"
						>
							Log Out
						</div>
					</div>
					<div :class="{ version: true, drawerMode: showAsideMenu }">
						<small>Version {{ appVersionNumber }}</small>
					</div>
				</div>
			</div>

			<switch-account
				id="switchAccountModal"
				v-if="isSwitchAccount"
				@close="
					isSwitchAccount = false;
					$emit('close');
				"
			></switch-account>
			<ResetPassword
				id="resetPasswordModal"
				:showing.sync="isResetPassword"
				@close="
					isResetPassword = false;
					$emit('close');
				"
			></ResetPassword>
		</div>
	</div>
</template>
<script>
import Auth from "@aws-amplify/auth";
import { removeUserData } from "../utils/auth";
import ChangePassword from "./ChangePassword";
import ResetPassword from "./ResetPassword";
import SwitchAccount from "./SwitchAccount";
import { mapState } from "vuex";

export default {
	name: "Sidebar",
	data: function() {
		return {
			selectedMenu: "",
			isResetPassword: false,
			isSwitchAccount: false,
			teamRole: "basic"
		};
	},
	computed: {
		...mapState(["showAsideMenu", "appVersionNumber", "team"])
	},
	watch: {
		team() {
			this.teamRole = this.team ? this.team.role : "basic";
		}
	},
	components: {
		ChangePassword,
		ResetPassword,
		SwitchAccount
	},
	mounted() {
		var currentUrl = window.location.href;
		var currentPage = currentUrl.substring(currentUrl.lastIndexOf("/") + 1);
		if (currentPage === "" || currentPage === "expenses") {
			this.selectedMenu = "expenses";
		} else if (currentPage === "overview") {
			this.selectedMenu = "overview";
		} else if (currentPage === "export") {
			this.selectedMenu = "export";
		} else if (currentPage === "rapid-email") {
			this.selectedMenu = "rapid-email";
		} else if (currentPage === "team") {
			this.selectedMenu = "team";
		} else if (currentPage === "setting") {
			this.selectedMenu = "settings";
		} else {
			this.selectedMenu = "expenses";
		}

		if (screen.width < 769) {
			this.$store.dispatch("clickHamburger", { value: false });
		}

		window.addEventListener("resize", () => {
			this.$store.dispatch("clickHamburger", {
				value: screen.width < 769 ? false : true
			});
		});
	},
	methods: {
		signOut() {
			Auth.signOut()
				.then(data => {
					removeUserData();
					this.$router.push({ name: "signin" });
				})
				.catch(err => console.log(err));
		},
		showChangePwdModal() {
			this.isResetPassword = true;
		},
		showSwitchAccountModal() {
			this.isSwitchAccount = true;
		},
		menuCollapse() {
			this.$store.dispatch("clickHamburger", { value: !this.showAsideMenu });
			return;
		}
	}
};
</script>
